import { Component } from '@angular/core';
import { ApiService } from '../../../../service/api.service';

@Component({
    selector: 'app-page-terms',
    templateUrl: './page-terms.component.html',
    styleUrls: ['./page-terms.component.scss'],
})
export class PageTermsComponent {
    data:any;
    constructor(
        private service : ApiService
    ) {
        this.service.getTermAndCondition().subscribe((res:any) => {
            this.data = res[0].data
        })
     }
}
